<template>
  <div class="box">
    <a href="."> <span class="log"></span> </a>
    <section class="nav">
      <div
        v-for="(item, index) in navData"
        :key="item.text"
        :class="item.isActive ? 'active' : ''"
        @click="handleJump(item.routerName, index)"
      >
        {{ item.text }}
      </div>
    </section>
    <router-view></router-view>
    <footer>
      <p>
        广州迷说科技有限公司 联系邮箱：limingjun@imlianai.com
      </p>
      <div class="gongan">
        <a href="http://beian.miit.gov.cn/" target="_blank"
          >粤ICP备17116398号</a
        >
        <a
          target="_blank"
          href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=44010602010807"
        >
          <img src="~@/assets/gbeian.png" />粤公网安备 44010602010807号</a
        >
      </div>
    </footer>
  </div>
</template>
<script>
export default {
  data() {
    return {
      navData: [
        {
          text: "首页",
          routerName: "home",
          isActive: true
        },
        {
          text: "关于我们",
          routerName: "about",
          isActive: false
        },
        {
          text: "用户协议",
          routerName: "agreement",
          isActive: false
        }
      ]
    };
  },
  methods: {
    handleJump(routerName, index) {
      this.navData.forEach(item => {
        item.isActive = false;
      });
      this.navData[index].isActive = true;
      this.$router.replace({
        path: `/off/${routerName}`
      });
    },
    raduisUrl() {
      window.location.href = "http://beian.miit.gov.cn/";
    }
  }
};
</script>

<style lang="less" scoped>
.box {
  font-size: 100px;
  width: 100%;
  height: 100%;
  background: url("~@/assets/index.png");
  background-size: 100% 100%;
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  .log {
    display: block;
    width: 9.2%;
    height: 7%;
    position: absolute;
    background: url("~@/assets/logo.png");
    background-size: 100% 100%;
    left: 20%;
    top: 4%;
    z-index: 2;
  }
  .nav {
    width: 20%;
    height: 40px;
    position: absolute;
    top: 4%;
    right: 15%;
    display: flex;
    cursor: pointer;
    div {
      font-size: 18px;
      color: #333;
      margin-right: 10%;
    }
    .router-link-active {
      color: #ff2a65;
      font-weight: 600;
    }
    span {
      font-size: 24px;
      color: #999999;
      line-height: 40px;
      text-align: center;
    }
    span:first-child {
      margin-right: 10%;
    }
    .active {
      text-decoration: underline;
      color: #ff2a65;
      font-weight: 600;
    }
  }
  .beian {
    a {
      display: inline-block;
      height: 20px;
      line-height: 20px;
      img {
        float: left;
      }
      p {
        float: left;
        display: inline;
        height: 20px;
        line-height: 20px;
        color: #ffffff;
        margin: 0px 0px 0px 5px;
      }
    }
  }
  footer {
    position: absolute;
    font-size: 14px;
    color: #ffffff;
    bottom: 0.1rem;
    line-height: 0.3rem;
    p {
      color: black;
    }
    a:hover {
      cursor: pointer;
      text-decoration: underline;
    }
    .gongan {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 100%;
      text-align: center;
      a {
        height: 20px;
        line-height: 20px;
        margin-left: 0.1rem;
        img {
          float: left;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/pc.vue